import React from "react";
import { Coins } from "lucide-react";

const fmtUsd = (v) => (v < 0.01 ? `$${v.toFixed(4)}` : `$${v.toFixed(2)}`);
const fmtNum = (n) => (n || 0).toLocaleString();

// Estimated spend on the user's own LLM key, from provider-reported token counts.
export function UsageCost({ usage, label = "This analysis", testId = "usage-cost" }) {
  if (!usage) return null;
  if (!usage.calls) {
    return (
      <p className="text-xs text-muted-foreground flex items-center gap-1.5" data-testid={testId}>
        <Coins className="w-3.5 h-3.5 text-emerald-400" />
        {label}: loaded from cache — no new LLM calls, no cost.
      </p>
    );
  }
  return (
    <p className="text-xs text-muted-foreground flex flex-wrap items-center gap-x-1.5 gap-y-0.5" data-testid={testId}>
      <Coins className="w-3.5 h-3.5 text-amber-400" />
      <span>{label}: est.</span>
      <strong className="text-amber-300" data-testid={`${testId}-amount`}>
        {usage.cost_usd == null ? "price unknown for this model" : `≈ ${fmtUsd(usage.cost_usd)}`}
      </strong>
      <span>
        · {fmtNum(usage.input_tokens)} in / {fmtNum(usage.output_tokens)} out tokens · {usage.calls} LLM call{usage.calls === 1 ? "" : "s"} · {usage.model}
      </span>
    </p>
  );
}
